import React from 'react';



export default function ErrcEd() {

  return (
    <>
        <h1>THE ELIMINATE-REDUCE-RAISE-CREATE GRID</h1>
        <p>The Eliminate-Reduce-Raise-Create Grid is a matrix-like tool. It helps the team to form a strategy that break-off between differentiation and low cost.</p>
        <img src={`${process.env.PUBLIC_URL}/images/4. ercc-en.jpg`} style={{width: 600}}/>
        <p>
          The grid consists of four sections: reduce, eliminate, raise, and create.

          The «reduce» and «eliminate» sections consist of factors that provide a minimum or no benefit at all to the consumers. By doing this, you reduce costs without reducing the value of your offering.

          The «raise» and «create» sections consist of factors that provide significant value to consumers. This provides your offering value innovation.

        </p>

        <p>
          The main aim of this tool is to turn you key insights revealed by the path into the strategy that will provide both value innovation and low costs.
        </p>
        <h3>
          How to work with this instrument:
        </h3>
        <p>
          1. Determine which factors to eliminate, reduce, raise, and create.
        </p>

        <p>
          2. Fill in the Eliminate-Reduce-Raise-Create grid by placing factors in the right sections.
        </p>


        <h3>
          Rules:
        </h3>

        <p>
          1. Check that you are pursuing both differentiation and low costs.
        </p>
        <p>
          2. Remember to focus on using concrete factors that you can act on and can get a good sense of their cost implications. For instance, instead of reducing «inconvenience» you should reduce concrete actions that will create convenience for your buyers.
        </p>
        <p>
          3. For filling in sections «Eliminate», «Reduce» and «Raise» of the grid with factors use the main competition factors from the As-Is Strategy Canvas. In the «Create» section of the grid place new key factors that you’ve created and which will provide new kinds of value for buyers. In total, there can be from 1 to 5 new key factors.
        </p>



    </>
  )
}
